'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flash;

var _flash = require('../../actions/flash');

function getFlashMessage(action) {
  if (action.result && action.result.flash) return action.result.flash;
  if (action.result && action.result.error) return { message: action.result.error };
  return action.error;
}

function flash() {
  return function (store) {
    return function (next) {
      return function (action) {
        var flashObject = getFlashMessage(action);

        if (flashObject) {
          store.dispatch((0, _flash.setFlash)(flashObject));
        } else if (action.result || action.error) {
          store.dispatch((0, _flash.clearFlash)());
        }

        next(action);
      };
    };
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/store/middleware/flash.js
// module id = 2361
// module chunks = 0